module.exports = __webpack_public_path__ + "static/2-c017fe747268ddfb1e7c994f6c71c593.jpeg";